module.exports = {
    "source_code": "HLXEMS",
    "site_id": "online.ic.edu",
    "title": "Illinois College",
    "tfn": "217-631-8102",
    "url": "https://online.ic.edu",
    "gtm_code": "GTM-T3DZRNHD",
}